import React from 'react';
import { useParams } from 'react-router-dom';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const BlogPostPage = () => {
  const { slug } = useParams();

  return (
    <div>
      <PageHero
        eyebrow="Blog Zartoo"
        title="Artigos sobre gestão, tecnologia e inovação."
        subtitle={`Post: ${slug || 'conteudo'}`}
        primaryCta={{ label: 'Ver todos os posts', href: '/blog' }}
      />

      <section className="bg-white text-slate-900">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Conteúdo"
            title="Título do artigo"
            description="Meta: data, tempo de leitura e categoria."
            mode="light"
          />
          <div className="grid lg:grid-cols-[2fr_1fr] gap-10">
            <div className="space-y-6 text-slate-700">
              <p>Introdução ao tema com contexto e dados relevantes para distribuidores e varejo.</p>
              <h2 className="text-2xl font-semibold text-slate-900">Subtítulo de seção</h2>
              <p>Explique o benefício e conecte com soluções da Zartoo.</p>
              <h3 className="text-xl font-semibold text-slate-900">Checklist rápido</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Mapeie processos críticos</li>
                <li>Centralize dados e indicadores</li>
                <li>Ative automações estratégicas</li>
              </ul>
              <Card variant="light">
                <p className="text-slate-700">
                  CTA: Quer ver isso na prática? <a href="/demonstracao" className="text-[#1976D2] font-semibold">Agende uma demo</a>.
                </p>
              </Card>
            </div>
            <aside className="space-y-6">
              <Card variant="light">
                <h4 className="text-lg font-semibold">Posts relacionados</h4>
                <ul className="mt-3 space-y-2 text-sm text-slate-600">
                  <li>Geo-roteirização reduz custos</li>
                  <li>Como integrar ERP e APP</li>
                  <li>BI para decisões rápidas</li>
                </ul>
              </Card>
              <Card variant="light">
                <h4 className="text-lg font-semibold">Newsletter</h4>
                <p className="text-sm text-slate-600 mt-2">Receba conteúdos exclusivos.</p>
                <input className="w-full mt-3 rounded-lg border border-slate-200 px-3 py-2" placeholder="Seu e-mail" />
              </Card>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPostPage;
